export default {"src":"/_next/static/media/location-marker--accommodation-active.9d8899ac.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};